<div class="flex-content">
  <div class="content col-sm container-fluid">

    <div *ngFor="let data of downloads$ | async" class="row list">
      <!--<h2 class="year-title" [id]='id' >{{id}}</h2>-->
      <div class="col-sm-12 year display-4" [id]='data[0].year'>
        {{data[0].year}}
      </div>

      <div *ngFor="let download of data" class="data-box">
        <div class="data-img">
          <img default="./assets/imgs/no_image.jpg" [srcset]=" imgPath + download.img" [src]=" imgPath + download.img">
          
        </div>
        <div class="data-desc">
          <h3 >{{download.title}}</h3>
          <p class="menu01">{{download.desc}}</p>
        </div>
        <div class="data-type">
          <h5 *ngIf="download.file"><a  [href]='imgPath + download.file' target="_blank">{{download.type | uppercase }}</a><mat-icon class="material-icons">file_download</mat-icon></h5>
          <h5 *ngIf="download.link"><a [href]='imgPath + download.link'  target="_blank">{{download.type | uppercase }}</a></h5>
          
          <p class="menu01">
            {{download.additional}}
          </p>
        </div>
      </div>

      <hr/>

    </div>

  </div>
</div>



// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/main/main-content/archive-downloads/archive-downloads.component.html